import script from "./CodeMarkup.vue?vue&type=script&setup=true&lang=js"
export * from "./CodeMarkup.vue?vue&type=script&setup=true&lang=js"

import "./CodeMarkup.vue?vue&type=style&index=0&id=01acddbc&lang=scss"

const __exports__ = script;

export default __exports__